export const CLAUDE_CODE_ICON = `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="cb-icon">
  <!-- Ears -->
  <rect x="3.5" y="1.5" width="5" height="5" rx="1.5" fill="currentColor"/>
  <rect x="15.5" y="1.5" width="5" height="5" rx="1.5" fill="currentColor"/>
  <!-- Body -->
  <rect x="2.5" y="5.5" width="19" height="13" rx="3" fill="currentColor"/>
  <!-- Eyes -->
  <ellipse cx="9" cy="11.5" rx="2" ry="2.5" fill="white" opacity="0.95"/>
  <ellipse cx="15" cy="11.5" rx="2" ry="2.5" fill="white" opacity="0.95"/>
  <!-- Pupils -->
  <ellipse cx="9.6" cy="12" rx="1" ry="1.2" fill="#1C1917"/>
  <ellipse cx="15.6" cy="12" rx="1" ry="1.2" fill="#1C1917"/>
  <!-- Legs -->
  <rect x="6.5" y="18.5" width="4" height="3.5" rx="1.5" fill="currentColor"/>
  <rect x="13.5" y="18.5" width="4" height="3.5" rx="1.5" fill="currentColor"/>
</svg>`;

export const COWORK_ICON = `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="cb-icon">
  <!-- Lightning bolt -->
  <path d="M13.5 2L5 13.5h5.5L9 22l10-12h-5.5L15.5 2h-2z" fill="currentColor"/>
  <!-- Circuit path -->
  <path d="M12.8 7.2L10.2 11.5l2.2 4" stroke="var(--cb-icon-accent, white)" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
  <!-- Circuit nodes -->
  <circle cx="12.8" cy="7.2" r="1.3" fill="var(--cb-icon-accent, white)"/>
  <circle cx="10.2" cy="11.5" r="1.3" fill="var(--cb-icon-accent, white)"/>
  <circle cx="12.4" cy="15.5" r="1.3" fill="var(--cb-icon-accent, white)"/>
</svg>`;

export const COPY_ICON = `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" class="cb-icon-sm">
  <rect x="5" y="5" width="8" height="8" rx="1.5" stroke="currentColor" stroke-width="1.5" fill="none"/>
  <path d="M3 10V3.5A1.5 1.5 0 014.5 2H10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
</svg>`;

export const CHECK_ICON = `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" class="cb-icon-sm">
  <path d="M3 8.5l3.5 3.5L13 4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`;

export const DOWNLOAD_ICON = `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" class="cb-icon-sm">
  <path d="M8 2v8m0 0l-3-3m3 3l3-3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M3 12v1.5a1 1 0 001 1h8a1 1 0 001-1V12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
</svg>`;

export const CLOSE_ICON = `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" class="cb-icon-sm">
  <path d="M4 4l8 8m0-8l-8 8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
</svg>`;

export const TERMINAL_ICON = `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" class="cb-icon-sm">
  <rect x="1" y="2" width="14" height="12" rx="2" stroke="currentColor" stroke-width="1.5" fill="none"/>
  <path d="M4 6l3 2.5L4 11" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M9 11h3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
</svg>`;

export const DESKTOP_APP_ICON = `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="cb-launch-svg">
  <rect x="4" y="5" width="16" height="11" rx="1.5" stroke="currentColor" stroke-width="1.5" fill="none"/>
  <path d="M4 8.5h16" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
  <circle cx="6.5" cy="7" r="0.65" fill="currentColor"/>
  <circle cx="8.5" cy="7" r="0.65" fill="currentColor"/>
  <path d="M9 19.5h6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
  <path d="M8 16.5h8v3H8v-3z" stroke="currentColor" stroke-width="1.5" fill="none" stroke-linejoin="round"/>
</svg>`;
